/**
 * The enumerated types representing available sliding views in the application.
 *
 * @enum {string}
 * @readonly
 * @memberof Mojito.Applications.Sports.AppViewTypes
 */
export const SLIDING_VIEW_TYPES = {
    BETSLIP: 'betslip',
    SAVED_BET_DETAILS: 'saved-bet-details',
    YOUR_BETS_DETAILS: 'your-bets-details',
    OPEN_BETS: 'open-bets',
    AZ_MENU: 'az-menu',
    FOREIGN_WINDOW: 'foreign-window',
    MY_ACCOUNT: 'my-account',
};
